import React from "react";
import AddCard from "./AddCard";

function AddCardModal({
  closeModal,
  stripeCustomerId,
  setCreditCardsList,
  currentTab,
  setAchData,
  setCurrentCardNumber,
  setCurrentAccNumber,
  creditCardsList,
  achAccountList,
  setCardBrandName,
  setAddNewCartData,
  setAddNewACHAccountData,
  setErrorMsgPlaceOrder,
  setErrorMsg,
  canAddNewCard,
  canAddNewACH,
  currentFileRequired,
  translationKey,
}) {
  return (
    <div className="addCardModalWrapper">
      <div className="addCardModalContainer">
        <AddCard
          setCreditCardsList={setCreditCardsList}
          stripeCustomerId={stripeCustomerId}
          closeModal={closeModal}
          currentTab={currentTab}
          setAchData={setAchData}
          setCurrentCardNumber={setCurrentCardNumber}
          setCurrentAccNumber={setCurrentAccNumber}
          creditCardsList={creditCardsList}
          achAccountList={achAccountList}
          setCardBrandName={setCardBrandName}
          setAddNewCartData={setAddNewCartData}
          setAddNewACHAccountData={setAddNewACHAccountData}
          setErrorMsgPlaceOrder={setErrorMsgPlaceOrder}
          setErrorMsg={setErrorMsg}
          canAddNewCard={canAddNewCard}
          canAddNewACH={canAddNewACH}
          currentFileRequired={currentFileRequired}
          translationKey={translationKey}
        />
        <div className="addCardModalButtons">
          <button className="sec-btn" onClick={() => closeModal(false)}>
            {translationKey(currentFileRequired["CANCEL"])}
          </button>
        </div>
      </div>
    </div>
  );
}

export default AddCardModal;
